var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "dashboard_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M14.667,11.333V6.667A.646.646,0,0,1,15.333,6h6A.646.646,0,0,1,22,6.667v4.667a.646.646,0,0,1-.667.667h-6a.646.646,0,0,1-.667-.667ZM6,14V6.667A.646.646,0,0,1,6.667,6h6a.646.646,0,0,1,.667.667V14a.646.646,0,0,1-.667.667h-6A.646.646,0,0,1,6,14Zm8.667,7.333V14a.646.646,0,0,1,.667-.667h6A.646.646,0,0,1,22,14v7.333a.646.646,0,0,1-.667.667h-6a.646.646,0,0,1-.667-.667ZM6,21.333V16.667A.646.646,0,0,1,6.667,16h6a.646.646,0,0,1,.667.667v4.667a.646.646,0,0,1-.667.667h-6A.646.646,0,0,1,6,21.333Zm1.333-8H12v-6H7.333ZM16,20.667h4.667v-6H16Zm0-10h4.667V7.333H16Zm-8.667,10H12V17.333H7.333ZM12,13.333ZM16,10.667ZM16,14.667ZM12,17.333Z",
    transform: "translate(-6 -6)",
    fill: "#024ea2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.78364cb9656cfc7792b2491be90b2c79.svg";
export { ForwardRef as ReactComponent };